import { render, staticRenderFns } from "./ValueChart.vue?vue&type=template&id=01dd4f28&scoped=true"
import script from "./ValueChart.vue?vue&type=script&lang=js"
export * from "./ValueChart.vue?vue&type=script&lang=js"
import style0 from "./ValueChart.vue?vue&type=style&index=0&id=01dd4f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd4f28",
  null
  
)

export default component.exports